import {Box} from '@mui/material'
import React from 'react'

const TabPanel = ({children, value, index, ...p}) => {
    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...p}>
            {value === index && <Box sx={{p: 3}}>{children}</Box>}
        </Box>
    )
}

export default TabPanel
